module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/warrantyType/warranty-type-list/warranty-type-list.component.css
// module id = ./src/app/warrantyType/warranty-type-list/warranty-type-list.component.css
// module chunks = main